import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { colors } from '@vds/theme';
import { Line as CoreLine } from '@vds-core/lines';

var Line = function Line(props) {
  function _calculateLineColor(type, inverted) {
    var lineColor = colors.black;
    if (type === 'accent') lineColor = colors.red;else if (inverted) {
      if (type === 'xLight') lineColor = colors.coolGray10;else lineColor = colors.white;
    } else if (type === 'xLight') lineColor = colors.coolGray3;
    return lineColor;
  }

  return /*#__PURE__*/React.createElement(CoreLine, _extends({}, props, {
    noMargin: true,
    calculateLineColor: _calculateLineColor
  }));
};

export default Line;